import axios from 'axios';

import { OKTA_CLIENT_ID } from '../components/AppV2/RoutesV2';

export const protectApiViaOkta = (method, url, data, headers) => {
  const oktaIdToken = JSON.parse(
    localStorage.getItem(`okta-token-storage-mkii-${OKTA_CLIENT_ID}`),
  )?.idToken?.idToken?.trim();

  try {
    const response = axios({
      method: method,
      url: url,
      data: data,
      headers: {
        ...headers,
        oktaidtoken: oktaIdToken,
      },
    });

    return response;
  } catch (e) {
    console.error('Error while executing API', e);
  }
};
